import React, { useState } from 'react';
import { PageHeader } from '../common';
import OverviewPanel from './OverviewPanel';
import EventsPanel from './EventsPanel';
import AuditPanel from './AuditPanel';
import PerformancePanel from './PerformancePanel';
import UsersActivityPanel from './UsersActivityPanel';
import ErrorsPanel from './ErrorsPanel';
import SecurityPanel from './SecurityPanel';
import SecurityReportsPanel from './SecurityReportsPanel';
import ZapScanPanel from './ZapScanPanel';
import PurgeSettingsPanel from './PurgeSettingsPanel';
import OCRPanel from './OCRPanel';
import CloudUsagePanel from './CloudUsagePanel';
import OCRSettingsPanel from './OCRSettingsPanel';
import SystemStatusPanel from './SystemStatusPanel';
import EmailLogsPanel from './EmailLogsPanel';

const TABS = [
  { id: 'overview', name: 'Apercu', icon: '' },
  { id: 'events', name: 'Evenements', icon: '' },
  { id: 'audit', name: 'Audit', icon: '' },
  { id: 'users', name: 'Utilisateurs', icon: '' },
  { id: 'ocr', name: 'OCR', icon: '' },
  { id: 'cloud', name: 'Cloud', icon: '' },
  { id: 'emails', name: 'Emails', icon: '' },
  { id: 'performance', name: 'Performance', icon: '' },
  { id: 'errors', name: 'Erreurs', icon: '' },
  { id: 'security', name: 'Securite', icon: '' },
  { id: 'ai-reports', name: 'Rapports IA', icon: '' },
  { id: 'zap-scan', name: 'Scan ZAP', icon: '' },
  { id: 'system-status', name: 'Status', icon: '' },
  { id: 'ocr-settings', name: 'Config OCR', icon: '' },
  { id: 'settings', name: 'Retention', icon: '' }
];

const AnalyticsDashboard = ({ token }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [dateRange, setDateRange] = useState({
    start: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
    end: new Date().toISOString().slice(0, 10)
  });

  const handleDateChange = (field, value) => {
    setDateRange(prev => ({ ...prev, [field]: value }));
  };

  const renderTab = () => {
    const props = { token, dateRange };

    switch (activeTab) {
      case 'overview':
        return <OverviewPanel {...props} />;
      case 'events':
        return <EventsPanel {...props} />;
      case 'audit':
        return <AuditPanel {...props} />;
      case 'users':
        return <UsersActivityPanel {...props} />;
      case 'ocr':
        return <OCRPanel {...props} />;
      case 'cloud':
        return <CloudUsagePanel {...props} />;
      case 'emails':
        return <EmailLogsPanel {...props} />;
      case 'performance':
        return <PerformancePanel {...props} />;
      case 'errors':
        return <ErrorsPanel {...props} />;
      case 'security':
        return <SecurityPanel {...props} />;
      case 'ai-reports':
        return <SecurityReportsPanel {...props} />;
      case 'zap-scan':
        return <ZapScanPanel {...props} />;
      case 'system-status':
        return <SystemStatusPanel {...props} />;
      case 'ocr-settings':
        return <OCRSettingsPanel {...props} />;
      case 'settings':
        return <PurgeSettingsPanel {...props} />;
      default:
        return <OverviewPanel {...props} />;
    }
  };

  return (
    <div style={{ padding: '0' }}>
      <PageHeader
        icon="📈"
        title="Analytics & Monitoring"
        color="purple"
        actions={
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            background: 'white',
            padding: '8px 16px',
            borderRadius: '10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}>
            <label style={{ fontSize: '13px', color: '#666' }}>Periode :</label>
            <input
              type="date"
              value={dateRange.start}
              onChange={(e) => handleDateChange('start', e.target.value)}
              style={{
                padding: '6px 10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '13px'
              }}
            />
            <span style={{ color: '#999' }}>-</span>
            <input
              type="date"
              value={dateRange.end}
              onChange={(e) => handleDateChange('end', e.target.value)}
              style={{
                padding: '6px 10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '13px'
              }}
            />
          </div>
        }
      />

      {/* Onglets */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '24px',
        borderBottom: '2px solid #eee',
        paddingBottom: '12px',
        overflowX: 'auto'
      }}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 20px',
              background: activeTab === tab.id
                ? 'linear-gradient(135deg, #9c27b0, #7b1fa2)'
                : 'white',
              color: activeTab === tab.id ? 'white' : '#666',
              border: activeTab === tab.id ? 'none' : '1px solid #ddd',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab.id ? '600' : '400',
              transition: 'all 0.2s ease',
              whiteSpace: 'nowrap'
            }}
          >
            <span>{tab.icon}</span>
            <span>{tab.name}</span>
          </button>
        ))}
      </div>

      {/* Contenu de l'onglet */}
      <div>
        {renderTab()}
      </div>
    </div>
  );
};

export default AnalyticsDashboard;
